'use client';
import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import GridTable from '../../shared/components/grid/GridTable';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider, {
  useColumnContextAPI,
} from '../../shared/context/GetAllColumnContext';
import { useEffect, useState } from 'react';
import { getUsersService } from '../../features/role-assignment/services/getUsers';
import CommitHandler from '../../features/role-assignment/components/CommitHandler';
import { SetRowLogic } from '../../features/role-assignment/setRowLogic';
import { t } from '../../i18next';
import { useConfigContext } from '../../shared/context/ConfigContext';

const RoleAssignmentScreen = () => {
  const { loading, error, screenTables } = useFetchScreenDetails('role_assignment');

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {!screenTables
            ? null
            : screenTables.map((item) => (
                <GetAllColumnContextProvider key={item.id}>
                  <RoleAssignment tableRes={item} />
                </GetAllColumnContextProvider>
              ))}
        </Layout>
      )}
    </>
  );
};

export default RoleAssignmentScreen;

const RoleAssignment = ({ tableRes }) => {
  const { configSchema } = useConfigContext();
  const { updateCustomConfig } = useColumnContextAPI();
  const [users, setUsers] = useState(null);

  useEffect(() => {
    getUsers({ setUsers, configSchema, screenGridId: tableRes.id });
  }, []);

  useEffect(() => {
    updateCustomConfig({
      SetRowLogic,
      SetIsCellEditable,
      CommitHandler,
      //SetColumnConfig: RoleAssignmentColumnConfig,
      ScreenSlotProps: { users },
    });
  }, [users]);

  return <GridTable tableRes={tableRes} />;
};

function SetIsCellEditable(props) {
  const { field, row, access } = props;

  let isEditable = true;
  if (field === 'user_account_id' && row.status !== 'N') {
    isEditable = false;
    return isEditable;
  }

  const rolePermission = access?.[field]?.accessLevel === 'U';
  return row.status !== 'D' && access?.edit_row && isEditable && rolePermission;
}

async function getUsers({ setUsers, configSchema, screenGridId }) {
  const resp = await getUsersService(screenGridId, configSchema);
  const data = resp?.[`${configSchema}_mbd_users`] ?? [];

  setUsers(data);
}
